import classNames from 'classnames';

import styles from '../../MarketCapRadar.module.scss';

const MarketCapRadarLoaderRow = () => (
  <div className={styles.tableRow}>
    <div className={styles.wrapperCompany}>
      <div className={styles.loadingLogo} />
      <div className={styles.companyInfo}>
        <div className={classNames(styles.loadingComponent, styles.loadingComponentMargin)} />
        <div className={styles.loadingComponent} style={{ width: 96 }} />
      </div>
    </div>
    <div className={styles.marketCapCell}>
      <div className={styles.loadingComponent} style={{ width: 48 }} />
    </div>
    <div className={styles.priceChange}>
      <div className={styles.priceAndChangeContainer}>
        <div className={classNames(styles.loadingComponent, styles.loadingComponentMargin)} style={{ width: 40 }} />
        <div className={styles.loadingComponent} style={{ width: 50 }} />
      </div>
    </div>
  </div>
);

export default MarketCapRadarLoaderRow;
